import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02e1c652"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left fontCoarse",
  style: {
    "height": "92px",
    "align-items": "center",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "平平"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "u-batNum"
};
const _hoisted_5 = {
  class: "u-img"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "胜胜"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "胜平"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "胜负"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "平胜"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_11 = {
  class: "content"
};
const _hoisted_12 = {
  class: "u-batNum"
};
const _hoisted_13 = {
  class: "u-img"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = {
  class: "u-batNum"
};
const _hoisted_17 = {
  class: "u-img"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "content"
};
const _hoisted_20 = {
  class: "u-batNum"
};
const _hoisted_21 = {
  class: "u-img"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "content"
};
const _hoisted_24 = {
  class: "u-batNum"
};
const _hoisted_25 = {
  class: "u-img"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "平负"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "负胜"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "负平"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "负负"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_31 = {
  class: "content"
};
const _hoisted_32 = {
  class: "u-batNum"
};
const _hoisted_33 = {
  class: "u-img"
};
const _hoisted_34 = ["src"];
const _hoisted_35 = {
  class: "content"
};
const _hoisted_36 = {
  class: "u-batNum"
};
const _hoisted_37 = {
  class: "u-img"
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "content"
};
const _hoisted_40 = {
  class: "u-batNum"
};
const _hoisted_41 = {
  class: "u-img"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = {
  class: "content"
};
const _hoisted_44 = {
  class: "u-batNum"
};
const _hoisted_45 = {
  class: "u-img"
};
const _hoisted_46 = ["src"];
import { ref } from 'vue';
export default {
  __name: 'HafuView',
  setup(__props, {
    expose: __expose
  }) {
    const hafuList = ref([]);
    const changeList = ref([]);
    const pushHafuList = list => {
      hafuList.value = list;
      if (list.length > 0) {
        let up = "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png";
        let down = "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png";
        let initHufa = list[0];
        let lastHufa = list[list.length - 1];
        let change = [];
        let hhf = 0;
        let hdf = 0;
        let haf = 0;
        let dhf = 0;
        let ddf = 0;
        let daf = 0;
        let ahf = 0;
        let adf = 0;
        let aaf = 0;
        change.push({
          name: "初始:" + initHufa.updateTime,
          hh: initHufa.hh,
          hd: initHufa.hd,
          ha: initHufa.ha,
          dh: initHufa.dh,
          dd: initHufa.dd,
          da: initHufa.da,
          ah: initHufa.ah,
          ad: initHufa.ad,
          aa: initHufa.aa,
          hhf: hhf,
          hdf: hdf,
          haf: haf,
          dhf: dhf,
          ddf: ddf,
          daf: daf,
          ahf: ahf,
          adf: adf,
          aaf: aaf
        });
        hhf = parseFloat(initHufa.hh) > parseFloat(lastHufa.hh) ? down : parseFloat(initHufa.hh) < parseFloat(lastHufa.hh) ? up : '';
        hdf = parseFloat(initHufa.hd) > parseFloat(lastHufa.hd) ? down : parseFloat(initHufa.hd) < parseFloat(lastHufa.hd) ? up : '';
        haf = parseFloat(initHufa.ha) > parseFloat(lastHufa.ha) ? down : parseFloat(initHufa.ha) < parseFloat(lastHufa.ha) ? up : '';
        dhf = parseFloat(initHufa.dh) > parseFloat(lastHufa.dh) ? down : parseFloat(initHufa.dh) < parseFloat(lastHufa.dh) ? up : '';
        ddf = parseFloat(initHufa.dd) > parseFloat(lastHufa.dd) ? down : parseFloat(initHufa.dd) < parseFloat(lastHufa.dd) ? up : '';
        daf = parseFloat(initHufa.da) > parseFloat(lastHufa.da) ? down : parseFloat(initHufa.da) < parseFloat(lastHufa.da) ? up : '';
        ahf = parseFloat(initHufa.ah) > parseFloat(lastHufa.ah) ? down : parseFloat(initHufa.ah) < parseFloat(lastHufa.ah) ? up : '';
        adf = parseFloat(initHufa.ad) > parseFloat(lastHufa.ad) ? down : parseFloat(initHufa.ad) < parseFloat(lastHufa.ad) ? up : '';
        aaf = parseFloat(initHufa.aa) > parseFloat(lastHufa.aa) ? down : parseFloat(initHufa.aa) < parseFloat(lastHufa.aa) ? up : '';
        change.push({
          name: "最新:" + lastHufa.updateTime,
          hh: lastHufa.hh,
          hd: lastHufa.hd,
          ha: lastHufa.ha,
          dh: lastHufa.dh,
          dd: lastHufa.dd,
          da: lastHufa.da,
          ah: lastHufa.ah,
          ad: lastHufa.ad,
          aa: lastHufa.aa,
          hhf: hhf,
          hdf: hdf,
          haf: haf,
          dhf: dhf,
          ddf: ddf,
          daf: daf,
          ahf: ahf,
          adf: adf,
          aaf: aaf
        });
        changeList.value = change;
      }
    };
    // 暴露给外部使用的函数
    __expose({
      pushHafuList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("半全场胜平负")]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(change.name), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 24
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(change.dd), 1), _createElementVNode("span", _hoisted_5, [_createElementVNode("img", {
                  alt: "",
                  src: change.ddf
                }, null, 8, _hoisted_6)])])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_8]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_9]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_10]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(change.hh), 1), _createElementVNode("span", _hoisted_13, [_createElementVNode("img", {
                  alt: "",
                  src: change.hhf
                }, null, 8, _hoisted_14)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(change.hd), 1), _createElementVNode("span", _hoisted_17, [_createElementVNode("img", {
                  alt: "",
                  src: change.hdf
                }, null, 8, _hoisted_18)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(change.ha), 1), _createElementVNode("span", _hoisted_21, [_createElementVNode("img", {
                  alt: "",
                  src: change.haf
                }, null, 8, _hoisted_22)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString(change.dh), 1), _createElementVNode("span", _hoisted_25, [_createElementVNode("img", {
                  alt: "",
                  src: change.dhf
                }, null, 8, _hoisted_26)])])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_27]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_28]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_29]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_30]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(change.da), 1), _createElementVNode("span", _hoisted_33, [_createElementVNode("img", {
                  alt: "",
                  src: change.daf
                }, null, 8, _hoisted_34)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(change.ah), 1), _createElementVNode("span", _hoisted_37, [_createElementVNode("img", {
                  alt: "",
                  src: change.ahf
                }, null, 8, _hoisted_38)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(change.ad), 1), _createElementVNode("span", _hoisted_41, [_createElementVNode("img", {
                  alt: "",
                  src: change.adf
                }, null, 8, _hoisted_42)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(change.aa), 1), _createElementVNode("span", _hoisted_45, [_createElementVNode("img", {
                  alt: "",
                  src: change.aaf
                }, null, 8, _hoisted_46)])])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))], 64);
    };
  }
};